(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Logger"), require("Alert"));
	else if(typeof define === 'function' && define.amd)
		define(["Logger", "Alert"], factory);
	else if(typeof exports === 'object')
		exports["ModManager"] = factory(require("Logger"), require("Alert"));
	else
		root["ModManager"] = factory(root["Logger"], root["Alert"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__libs_logger__, __WEBPACK_EXTERNAL_MODULE__libs_sweetalert__) => {
return 